<template>
  <div class="main">
    <b-card>
      <b-card-body>
        <b-row class="mb-2">
          <b-col md="12" class="d-flex justify-content-end">
            <router-link :to="{ path: '/delivery/DeliveryManagement/AddDelivery/add-delivery', }">
              <b-button variant="primary">
                <feather-icon icon="PlusIcon" class="mr-50" />
                New Delivery
              </b-button>
            </router-link>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" md="2" sm="1" class="my-1">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">Per page</label>
              <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions"  />
            </b-form-group>
          </b-col>

          <b-col cols="12" class="d-flex justify-content-end mb-2" style="position: relative; z-index: 1;">
            <b-button variant="outline-danger"  @click="clearFilters">
              Clear Filters
            </b-button>
          </b-col>

          <b-col cols="12">
            <b-table striped hover responsive :per-page="perPage" :current-page="currentPage"
              :items="filteredDeliveries" :fields="deliveryFields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection" @filtered="onFiltered">

              <!-- Column Filters -->
              <template #head(vehicleID)="scope">
                <div class="d-flex flex-column">
                  <span>Vehicle</span>
                  <b-form-input v-model="filters.vehicle" placeholder="Search Vehicle" size="sm"
                    @input="currentPage = 1" />
                </div>
              </template>

              <template #head(pickUpLocation)="scope">
                <div class="d-flex flex-column">
                  <span>Pickup Location</span>
                  <b-form-input v-model="filters.pickup" placeholder="Search Pickup Location" size="sm"
                    @input="currentPage = 1" />
                </div>
              </template>

              <template #head(dropOffLocation)="scope">
                <div class="d-flex flex-column">
                  <span>Dropoff Location</span>
                  <b-form-input v-model="filters.dropoff" placeholder="Search Dropoff Location" size="sm"
                    @input="currentPage = 1" />
                </div>
              </template>

              <template #head(deliveryStatus)="scope">
                <div class="d-flex flex-column">
                  <span>Delivery Status</span>
                  <b-form-select v-model="filters.status" :options="statusOptions" size="sm"
                    @change="currentPage = 1" />
                </div>
              </template>

              <template #head(note)="scope">
                <div class="d-flex flex-column">
                  <span>Notes</span>
                  <b-form-input v-model="filters.note" placeholder="Search Notes" size="sm" @input="currentPage = 1" />
                </div>
              </template>

              <template #cell(vehicleID)="data">
                {{ getVehiclemake(data.item.vehicleID) }}
              </template>

              <template #cell(driverID)="data">
                {{ getDriverName(data.item.driverID) }}
              </template>

              <!-- Template for the delivery status column -->
              <template #cell(deliveryStatus)="data">
                <b-badge :variant="statusVariants[data.value]">{{ data.value }}</b-badge>
              </template>
              <!-- Template for the actions column -->
              <template #cell(actions)="data">
          
                <b-dropdown variant="link" toggle-class="p-0" no-caret class="m-1">
                  <template #button-content>
                    <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
                  </template>
                  <b-dropdown-item :to="{
                    name: 'view-delivery',
                    params: { id: data.item.id }
                  }">
                    <feather-icon icon="EyeIcon" />
                    <span class="align-middle ml-1">View</span>
                  </b-dropdown-item>
                  <b-dropdown-item :to="{
                    name: 'edit-delivery',
                    params: { id: data.item.id }
                  }">
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-1">Edit</span>
                  </b-dropdown-item>
                  <b-dropdown-item  :disabled="data.item.deliveryStatus === 'DELIVERED'"  @click="confirmDeleteDelivery(data.item.id)">
                    <feather-icon icon="TrashIcon" />
                    <span class="align-middle ml-1">Delete</span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <div class="d-flex justify-content-center mb-1">
              <div class="d-flex justify-content-center mb-1" v-if="loading">
                <b-spinner variant="success" label="Spinning" style="width: 3rem; height: 3rem"></b-spinner>
              </div>
            </div>
          </b-col>

          <b-col cols="12">
            <b-pagination v-model="currentPage" :total-rows="filteredDeliveries.length" :per-page="perPage" align="center" size="sm"
              class="my-0" />
              <b-form-group>
        Showing 
        {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
        to 
        {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
        of 
        {{ totalRows > 0 ? totalRows : 0 }} 
        entries
      </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import { BTable, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCard, BDropdown, BDropdownItem, BBadge, BSpinner, } from 'bootstrap-vue';
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
export default {
  components: {
    BCard,
    BTable,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BDropdown,
    BDropdownItem,
    BBadge, // Added BBadge component
    BSpinner,
  },
  data() {
    return {
      //deliveries: [], // Initialize as an empty array
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      filter: null,
      filterOn: ['pickUpLocation', 'dropOffLocation', 'deliveryStatus', 'note'],
      filters: {
        vehicle: '',
        pickup: '',
        dropoff: '',
        status: null,
        note: '',
      },
      statusOptions: [
        { value: null, text: 'All' },
        { value: 'PENDING', text: 'Pending' },
        { value: 'INTRANSIT', text: 'In Transit' },
        // { value: 'SCHEDULED', text: 'Scheduled' },
        { value: 'DELIVERED', text: 'Delivered' },
        { value: 'CANCELLED', text: 'Cancelled' },
        { value: 'RETURNED', text: 'Returned' },
      ],
      deliveryFields: [
        { key: 'vehicleID', label: 'Vehicle', sortable: true },
        { key: 'driverID', label: 'Driver', sortable: true },
        //{ key: 'deliveryDate', label: 'Drivery Date', sortable: true },
        { key: 'pickUpLocation', label: 'Pickup Location', sortable: true },
        { key: 'dropOffLocation', label: 'Dropoff Location', sortable: true },
        { key: 'deliveryStatus', label: 'Delivery Status', sortable: true },
        { key: 'note', label: 'Notes', sortable: true },
        { key: 'actions', label: 'Actions' },
      ],
      items: [],
      sortBy: null,
      sortDesc: null,
      sortDirection: null,
      statusVariants: {
        PENDING: 'danger',
        INTRANSIT: 'warning',
        DELIVERED: 'success',
        CANCELLED: 'dark',
        RETURNED: 'secondary'
        // Add more status and colors as needed
      },
    };
  },
  methods: {
    clearFilters() {
      this.filters = {
        vehicle: '',
        pickup: '',
        dropoff: '',
        status: null,
        note: '',
      };
      this.currentPage = 1; // Reset pagination
    },
    ...mapActions("vehicleModule", ["getVehicleListAction", "getVehicleByIDAction"]),
    ...mapActions("deliveriesModule", ["getDeliveryListAction", "deleteDeliveryAction", "getDeliveryItemListAction"]),
    ...mapActions("userModule", ["getUserListAction"]),
    data(data) {
      if (data) {
        this.getDeliveryListAction();
      }
    },

    getVehiclemake(id) {
      const vehiclemake = this.vehicles.find((s) => s.vehicleId === id);
      return vehiclemake ? vehiclemake.make : "-";
    },

    getDriverName(id) {
      const driver = this.users.find((s) => s.id === id);
      return driver ? driver.firstName + " " + driver.lastName : "-";
    },

    //formatDate : (deliveries) => new Date(deliveries.hireDate).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" }),

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // confirmDeleteDelivery(delivery) {
    //   Swal.fire({
    //     title: 'Are you sure?',
    //     text: "You won't be able to revert this!",
    //     icon: 'warning',
    //     showCancelButton: true,
    //     confirmButtonText: 'Yes, delete it!',
    //     customClass: {
    //       confirmButton: 'btn btn-primary',
    //       cancelButton: 'btn btn-outline-danger ml-1',
    //     },
    //     buttonsStyling: false,
    //   }).then((result) => {
    //     if (result.value) {
    //       this.deleteDelivery(delivery);
    //     } else if (result.dismiss === Swal.DismissReason.cancel) {
    //       Swal.fire({
    //         title: 'Cancelled',
    //         text: 'Your delivery is safe :)',
    //         icon: 'error',
    //         customClass: {
    //           confirmButton: 'btn btn-success',
    //         },
    //       });
    //     }
    //   });
    // },

    // deleteDelivery(delivery) {
    //   const index = this.deliveries.findIndex((d) => d.id === delivery.id);
    //   if (index !== -1) {
    //     this.deliveries.splice(index, 1);
    //     Swal.fire({
    //       title: 'Deleted!',
    //       text: 'The delivery has been deleted.',
    //       icon: 'success',
    //       customClass: {
    //         confirmButton: 'btn btn-success',
    //       },
    //     });
    //   }
    // },

    async confirmDeleteDelivery(id) {

      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteDeliveryAction(id)
            .then(() => {
              this.$swal({
                icon: 'success',
                title: 'Deleted!',
                text: 'Delivery has been deleted',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              });
              this.getDeliveryListAction().then(() => {
                this.totalRows = this.deliveries.length;
                // this.employeeListing = [...this.employeeList];
              });
              //window.location.reload();
            })
            .catch((error) => {
              this.$swal({
                icon: 'error',
                title: 'Error!',
                text: error.response.data.message,
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              });
              this.getDeliveryListAction().then(() => {
                this.totalRows = this.deliveries.length;
              });
            });
        } else if (result.dismiss === 'cancel') {
          this.$swal({
            title: 'Cancelled',
            text: 'Delivery not deleted',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          });
        }
      });
    },

    // getItems(id){
    //  const items = this.getDeliveryItemListAction(id);
    //  return items;
    // }

  },

  computed: {
    filteredDeliveries() {
      return this.deliveries.filter((delivery) => {
        const matchesVehicle =
          !this.filters.vehicle ||
          this.getVehiclemake(delivery.vehicleID)
            ?.toLowerCase()
            .includes(this.filters.vehicle.toLowerCase());
        const matchesPickup =
          !this.filters.pickup ||
          delivery.pickUpLocation
            ?.toLowerCase()
            .includes(this.filters.pickup.toLowerCase());
        const matchesDropoff =
          !this.filters.dropoff ||
          delivery.dropOffLocation
            ?.toLowerCase()
            .includes(this.filters.dropoff.toLowerCase());
        const matchesStatus =
          this.filters.status === null || delivery.deliveryStatus === this.filters.status;
        const matchesNote =
          !this.filters.note ||
          delivery.note?.toLowerCase().includes(this.filters.note.toLowerCase());

        return (
          matchesVehicle &&
          matchesPickup &&
          matchesDropoff &&
          matchesStatus &&
          matchesNote
        );
      });
    },
    ...mapGetters("deliveriesModule", {
      deliveries: "delivery",
      deliveryid: "deliveryid",
      loading: "loading",
    }),
    ...mapGetters("vehicleModule", {
      vehicles: "vehicles",
      loading: "loading",
    }),

    ...mapGetters("userModule", {
      users: "users",
      loading: "loading",
    }),
    // getVehicle(){
    //   const make = this.vehicleID.make;
    //   return make;
    // },
  },
  //   mounted() {
  //   // Set the initial number of items
  //   this.totalRows = this.items.length;
  //   this.getDelivery();
  // },
  async mounted() {
    // await this.getDeliveryListAction()
    //   .then((response) => {
    //     console.log(response);
    //   })
    //   .catch((response) => {
    //     console.log(response);
    //   });

    //   await this.getVehicleByIDAction(this.vehicleID);
    const deliveries = await this.getDeliveryListAction();

    this.deliveries = deliveries;

    this.totalRows = this.deliveries.length;

    await this.getVehicleListAction();

    await this.getUserListAction();

    // for (const delivery of deliveries) {
    //   const vehicle = await this.getVehicleByIDAction(delivery.vehicleID);
    //   delivery.vehicleMake = vehicle.make; 
    // }
    console.log("Initial items displayed in the table:", this.filteredDeliveries);
  },
};
</script>
<style scoped>
/* Add your existing styles here */
</style>
